// components/SetupChecklist.js
// Compact progress bar shown on the owner dashboard.
// Clicking opens the SetupWizard modal.

import React, { useState, useEffect, useCallback } from 'react';
import SetupWizard from './SetupWizard';

const API = process.env.REACT_APP_API_URL || 'https://brokerconnect.co.uk/api';

export default function SetupChecklist({ token, onComplete, compact = false }) {
  const [status,    setStatus]    = useState(null);
  const [loading,   setLoading]   = useState(true);
  const [dismissed, setDismissed] = useState(false);
  const [wizardOpen, setWizardOpen] = useState(false);

  const load = useCallback(async () => {
    try {
      const res  = await fetch(`${API}/agreement-templates/setup-status`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      setStatus(data);
      if (data.score === 100 && onComplete) onComplete();
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  }, [token, onComplete]);

  useEffect(() => { load(); }, [load]);

  // Re-poll every 15s so the bar updates after the broker finishes a step
  useEffect(() => {
    const t = setInterval(load, 15000);
    return () => clearInterval(t);
  }, [load]);

  if (loading || !status || dismissed || status.score === 100) return null;

  const items     = Object.entries(status.items || {});
  const remaining = items.filter(([, v]) => !v.done).length;

  const openWizard = () => setWizardOpen(true);
  const closeWizard = () => { setWizardOpen(false); load(); };

  return (
    <>
      <div
        onClick={openWizard}
        style={{
          background: '#fff',
          border: '1px solid #e2e8f0',
          borderRadius: 12,
          padding: '14px 20px',
          marginBottom: 24,
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: 16,
          transition: 'box-shadow 0.15s',
        }}
        title="Open setup wizard"
      >
        <div style={{ flex: 1 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 6 }}>
            <span style={{ fontSize: 13, fontWeight: 700, color: '#0e1b2c' }}>
              Setup {status.score}% complete
            </span>
            <span style={{ fontSize: 12, color: '#10b981', fontWeight: 600 }}>
              {remaining} step{remaining !== 1 ? 's' : ''} remaining — click to continue →
            </span>
          </div>
          <div style={{ height: 6, background: '#EDF2F7', borderRadius: 99, overflow: 'hidden' }}>
            <div style={{
              height: '100%',
              width: `${status.score}%`,
              background: 'linear-gradient(90deg, #10b981, #84cc16)',
              borderRadius: 99,
              transition: 'width 0.6s ease',
            }} />
          </div>
        </div>
        <button
          onClick={(e) => { e.stopPropagation(); setDismissed(true); }}
          style={{ background: 'none', border: 'none', fontSize: 18, color: '#a0aec0', cursor: 'pointer', padding: 4 }}
          title="Dismiss"
        >×</button>
      </div>

      {wizardOpen && (
        <SetupWizard token={token} onClose={closeWizard} />
      )}
    </>
  );
}
